import type { ColorValue, Theme } from '@anywayseo/tools';
import { TinyColor } from '@ctrl/tinycolor';


const DEFAULT_THEME: Theme = 'system';
const DEFAULT_COLOR = '#333333';

export function extractTheme(value: unknown, defaultTheme = DEFAULT_THEME): Theme {
  let theme = defaultTheme;

  if (value) {
    const themes: Theme[] = ['dark', 'light', 'system'];
    const probablyTheme = value as Theme;

    if (themes.includes(probablyTheme)) {
      theme = probablyTheme;
    }
  }

  return theme;
}

export function generateColorPalette(value: unknown, defaultColor = DEFAULT_COLOR): ColorValue {
  let baseColor = defaultColor;

  if (value && typeof value === 'string') {
    baseColor = value;
  }

  const color = new TinyColor(baseColor);

  return {
    50: color.lighten(52).toHexString(),
    100: color.lighten(40).toHexString(),
    200: color.lighten(30).toHexString(),
    300: color.lighten(20).toHexString(),
    400: color.lighten(10).toHexString(),
    500: color.toHexString(),
    600: color.darken(10).toHexString(),
    700: color.darken(20).toHexString(),
    800: color.darken(30).toHexString(),
    900: color.darken(40).toHexString(),
  };
}
